"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mkVisibilityChange = void 0;

var _throwError = require("../Observables/throwError");

var _fromEvent = require("../Observables/fromEvent");

var _map = require("../Observables/map");

var mkVisibilityChange = function mkVisibilityChange() {
  return !("onvisibilitychange" in document) ? (0, _throwError.throwError)("visibilitychange Not Supported") // : startWith({ hidden: document.hidden, init: true }, fromEvent(document, "visibilitychange"))
  : (0, _fromEvent.fromEvent)(document, "visibilitychange").pipe((0, _map.map)(function (_e) {
    return !document.hidden;
  }));
};

exports.mkVisibilityChange = mkVisibilityChange;